import React, { useEffect, useState } from "react";
import ResponsiveModalAbsolute from "../../components/ResponsiveModalAbsolute";
import HorarioAsesores from "../../../../api/models/horarios_asesores";
import Spinner from "../../components/helpers/Spinner";
import { fetchAxiosToken } from "../../helpers/fetchAxiosToken";
import { fetchAxiosNoToken } from "../../helpers/fetchAxiosNoToken";
import { useAppSelector } from "../../hooks/hooks";
import corredor from "../../redux/reducers/corredorReducer";
import Swal from "sweetalert2";
import { Label } from "components/ui/label";
import { Input } from "components/ui/input";

interface Props {
    modalHorario: boolean;
    setModalHorario: React.Dispatch<React.SetStateAction<boolean>>;
    getEvents: () => void;
}

interface Horario {
    lunes: number;
    martes: number;
    miercoles: number;
    jueves: number;
    viernes: number;
    sabado: number;
    domingo: number;

    lunes_opening: string;
    martes_opening: string;
    miercoles_opening: string;
    jueves_opening: string;
    viernes_opening: string;
    sabado_opening: string;
    domingo_opening: string;

    lunes_closing: string;
    martes_closing: string;
    miercoles_closing: string;
    jueves_closing: string;
    viernes_closing: string;
    sabado_closing: string;
    domingo_closing: string;
    tiempo_visita: number;
}

const ModalHorario = ({ modalHorario, setModalHorario, getEvents }: Props) => {
    const corredor = useAppSelector((state) => state.corredor);
    const [loading, setLoading] = useState(false);
    const [loadingButton, setLoadingButton] = useState(false);

    const [isHorario, setIsHorario] = useState(false);

    const diasSemana = [
        { key: "lunes", label: "Lunes" },
        { key: "martes", label: "Martes" },
        { key: "miercoles", label: "Miércoles" },
        { key: "jueves", label: "Jueves" },
        { key: "viernes", label: "Viernes" },
        { key: "sabado", label: "Sábado" },
        { key: "domingo", label: "Domingo" },
    ];

    const [accordionOpen, setAccordionOpen] = useState<Record<string, boolean>>(
        {
            lunes: false,
            martes: false,
            miercoles: false,
            jueves: false,
            viernes: false,
            sabado: false,
            domingo: false,
        }
    );

    const [HorarioAsesores, setHorarioAsesores] = useState<Horario>({
        lunes: 1,
        martes: 1,
        miercoles: 1,
        jueves: 1,
        viernes: 1,
        sabado: 0,
        domingo: 0,
        lunes_opening: "08:00",
        martes_opening: "08:00",
        miercoles_opening: "08:00",
        jueves_opening: "08:00",
        viernes_opening: "08:00",
        sabado_opening: "08:00",
        domingo_opening: "08:00",
        lunes_closing: "18:00",
        martes_closing: "18:00",
        miercoles_closing: "18:00",
        jueves_closing: "18:00",
        viernes_closing: "18:00",
        sabado_closing: "18:00",
        domingo_closing: "18:00",
        tiempo_visita: 30,
    });

    useEffect(() => {
        if (modalHorario) getHorario();
    }, [modalHorario]);

    const getHorario = async () => {
        setLoading(true);
        const data = await fetchAxiosNoToken({
            url: `/horarios_asesores/${corredor.id}`,
            method: "get",
        });
        console.log("data", data);
        if (data.is_horario === "Si") {
            setHorarioAsesores(data.data);
            setIsHorario(true);
        }

        setLoading(false);
    };

    const handleGuardar = async () => {
        setLoadingButton(true);

        try {
            if (!isHorario) {
                const data = await fetchAxiosToken({
                    url: `/horarios_asesores/`,
                    method: "post",
                    body: {
                        id_corredor: corredor.id,
                        ...HorarioAsesores,
                    },
                });
                setIsHorario(true);
                Swal.fire({
                    icon: "success",
                    title: "Guardado exitoso",
                    text: "Horario guardado",
                });
            } else {
                const data = await fetchAxiosToken({
                    url: `/horarios_asesores/${corredor.id}`,
                    method: "put",
                    body: {
                        id_corredor: corredor.id,
                        ...HorarioAsesores,
                    },
                });

                Swal.fire({
                    icon: "success",
                    title: "Actualización exitosa",
                    text: "Horario guardado",
                });
            }
            await getEvents();

            setModalHorario(false);
        } catch (error) {
            console.error(error);
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Ocurrió un error al guardar el horario",
            });
        } finally {
            setLoadingButton(false);
        }
    };

    return (
        <div>
            <ResponsiveModalAbsolute
                modalVisible={modalHorario}
                setModalVisible={setModalHorario}>
                <div className="flex flex-col items-center justify-center">
                    <div className="text-xl font-bold text-center">
                        Editar Horarios
                    </div>

                    <div className="mt-2 text-base text-center ">
                        Días y horarios disponibles
                    </div>

                    {loading ? (
                        <div className="w-full">
                            {" "}
                            <Spinner></Spinner>
                        </div>
                    ) : (
                        <div className="w-full max-w-md p-1 mt-4 border rounded-lg border-blue-blueFrom">
                            <div className="flex items-center justify-center w-full gap-3 pb-3 max-w-[420px]">
                                <Label
                                    className="text-blue-consulta-800"
                                    htmlFor="biografia">
                                    Tiempo por visita
                                </Label>
                                <div className="relative">
                                    <Input
                                        min={0}
                                        type={"number"}
                                        name={"time_consultation"}
                                        id={"time_consultation"}
                                        onChange={(e) =>
                                            setHorarioAsesores({
                                                ...HorarioAsesores,
                                                tiempo_visita: parseInt(
                                                    e.target.value
                                                ),
                                            })
                                        }
                                        value={
                                            HorarioAsesores.tiempo_visita || ""
                                        }
                                        placeholder="30"
                                    />
                                </div>
                                <Label
                                    className="text-blue-consulta-800"
                                    htmlFor="biografia">
                                    Min
                                </Label>
                            </div>
                            {diasSemana.map((dia) => (
                                <div
                                    key={dia.key}
                                    className="mt-2 border-b last:border-none">
                                    {/* Encabezado del día */}
                                    <div
                                        className="flex items-center justify-between p-2 cursor-pointer"
                                        onClick={() =>
                                            setAccordionOpen((prev) => ({
                                                ...prev,
                                                [dia.key]: !prev[dia.key],
                                            }))
                                        }>
                                        <span className="font-semibold">
                                            {dia.label}
                                        </span>
                                        <div className="flex items-center gap-2">
                                            {/* Toggle */}
                                            <label className="inline-flex items-center cursor-pointer">
                                                <input
                                                    type="checkbox"
                                                    className="sr-only peer"
                                                    checked={
                                                        HorarioAsesores[
                                                            dia.key as keyof Horario
                                                        ] === 1
                                                    }
                                                    onChange={() =>
                                                        setHorarioAsesores(
                                                            (prev) => ({
                                                                ...prev,
                                                                [dia.key]:
                                                                    prev[
                                                                        dia.key as keyof Horario
                                                                    ] === 1
                                                                        ? 0
                                                                        : 1,
                                                            })
                                                        )
                                                    }
                                                />
                                                <div className="relative h-6 transition-colors bg-gray-200 rounded-full w-11 peer-checked:bg-blue-600">
                                                    <div
                                                        className={`absolute top-1 bg-white w-4 h-4 rounded-full transition-all ${
                                                            HorarioAsesores[
                                                                dia.key as keyof Horario
                                                            ] === 1
                                                                ? "left-[24px]"
                                                                : "left-1"
                                                        }`}></div>
                                                </div>
                                            </label>

                                            {/* Flecha */}
                                            <svg
                                                className={`w-5 h-5 transform transition-transform duration-200 ${
                                                    accordionOpen[dia.key]
                                                        ? "rotate-180"
                                                        : ""
                                                }`}
                                                fill="none"
                                                stroke="currentColor"
                                                viewBox="0 0 24 24"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth={2}
                                                    d="M19 9l-7 7-7-7"
                                                />
                                            </svg>
                                        </div>
                                    </div>

                                    {/* Cuerpo del acordeón */}
                                    {accordionOpen[dia.key] && (
                                        <div className="flex flex-col gap-2 px-4 pb-4">
                                            <div className="flex items-center justify-between">
                                                <label>Desde:</label>
                                                <input
                                                    type="time"
                                                    className="px-2 py-1 border rounded-lg"
                                                    value={String(
                                                        HorarioAsesores[
                                                            `${dia.key}_opening` as keyof Horario
                                                        ]
                                                    ).slice(0, 5)}
                                                    onChange={(e) =>
                                                        setHorarioAsesores(
                                                            (prev) => ({
                                                                ...prev,
                                                                [`${dia.key}_opening`]:
                                                                    e.target
                                                                        .value,
                                                            })
                                                        )
                                                    }
                                                />
                                            </div>
                                            <div className="flex items-center justify-between">
                                                <label>Hasta:</label>
                                                <input
                                                    type="time"
                                                    className="px-2 py-1 border rounded-lg"
                                                    value={String(
                                                        HorarioAsesores[
                                                            `${dia.key}_closing` as keyof Horario
                                                        ]
                                                    ).slice(0, 5)}
                                                    onChange={(e) =>
                                                        setHorarioAsesores(
                                                            (prev) => ({
                                                                ...prev,
                                                                [`${dia.key}_closing`]:
                                                                    e.target
                                                                        .value,
                                                            })
                                                        )
                                                    }
                                                />
                                            </div>
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    )}

                    {!loading && (
                        <button
                            disabled={loadingButton}
                            className="px-5 py-3 mt-5 text-white rounded-lg bg-blue-blueFrom hover:scale-105 w-60"
                            onClick={handleGuardar}>
                            {loadingButton ? <Spinner width={6} /> : "Guardar"}
                        </button>
                    )}
                </div>
            </ResponsiveModalAbsolute>
        </div>
    );
};

export default ModalHorario;
